var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('svg',{class:_setup.spinner({ size: _setup.props.size }),attrs:{"viewBox":"0 0 20 20"}},[_c('path',{attrs:{"d":"M7.229 1.173a9.25 9.25 0 1011.655 11.412 1.25 1.25 0 10-2.4-.698 6.75 6.75 0 11-8.506-8.329 1.25 1.25 0 10-.75-2.385z","fill":"currentColor"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }